import { useFormik } from 'formik';
import * as yup from 'yup';
import styles from './register.module.css';
import { Card, CardContent } from 'shared-components';
import { Button } from 'shared-components';
import { FormGroup } from 'shared-components';
import { Link } from 'react-router-dom';
import { Logo } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';
import { FormLayout } from 'shared-components';
import { EnvelopeIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';

export const Register = () => {
  const { handleSubmit, getFieldProps } = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: yup.object({
      email: yup.string().email('Invalid email').required('Required'),
      password: yup.string().required('Required'),
    }),
    onSubmit: async (values) => {
      // const result = await login(values);
      // if ('error' in result) {
      //   console.error(result.error);
      // } else if ('data' in result) {
      //   //localStorage.setItem('auth_token', result.data.token);
      //   dispatch(setToken(result.data.token));
      // }
    },
  });
  return (
    <div className={styles.container}>
      <Logo />
      <Card className={styles.card}>
        <CardContent standalone={true}>
          <h2 className={styles.title}>Register</h2>
          <form className={styles.form} onSubmit={handleSubmit}>
            <FormLayout>
              <FormGroup>
                <Label htmlFor="email">Email</Label>
                <Input
                  withIcon={<EnvelopeIcon height={22} width={22} />}
                  placeholder="Enter your email"
                  bigger={true}
                  type="email"
                  id="email"
                  {...getFieldProps('email')}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="password">Password</Label>
                <Input
                  withIcon={<LockClosedIcon height={22} width={22} />}
                  bigger={true}
                  placeholder="6+ Characters, 1 Capital letter"
                  type="password"
                  id="password"
                  {...getFieldProps('password')}
                />
              </FormGroup>
              <FormGroup>
                <Button
                  bigger={true}
                  className={classNames('w-100', styles.button)}
                  type="submit"
                >
                  Register
                </Button>
              </FormGroup>
            </FormLayout>
            <p
              style={{
                marginTop: '1.5rem',
                textAlign: 'center',
              }}
            >
              {' '}
              Already registered? <Link to="/">Login now</Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
